export default __webpack_public_path__ + "static/media/Attender.4591d0d3.svg";